var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "page-student-edit" } },
    [
      _c(
        "vs-alert",
        {
          attrs: {
            color: "danger",
            title: "Aluno não encontrado!",
            active: _vm.student_not_found,
          },
          on: {
            "update:active": function ($event) {
              _vm.student_not_found = $event
            },
          },
        },
        [
          _c("span", [
            _vm._v(
              "O aluno com código: " +
                _vm._s(_vm.$route.params.studentId) +
                " não foi encontrado. "
            ),
          ]),
          _c(
            "span",
            [
              _c("span", [_vm._v("Verifique ")]),
              _c(
                "router-link",
                {
                  staticClass: "text-inherit underline",
                  attrs: { to: { name: "student-list" } },
                },
                [_vm._v("a lista de alunos")]
              ),
              _c("span", [
                _vm._v(" ou faça uma busca no campo do topo da página."),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm.ready
        ? _c("vx-card", [
            _c(
              "div",
              {
                staticClass: "tabs-container px-6 pt-6",
                attrs: { slot: "no-body" },
                slot: "no-body",
              },
              [
                _c(
                  "vs-tabs",
                  {
                    staticClass: "tab-action-btn-fill-conatiner",
                    model: {
                      value: _vm.activeTab,
                      callback: function ($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab",
                    },
                  },
                  [
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Dados Gerais",
                          "icon-pack": "feather",
                          icon: "icon-user",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [
                            _c("student-edit-tab-general-data", {
                              ref: "student_edit_tab_general_data",
                              staticClass: "mt-4",
                              attrs: { states: _vm.states },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Dados Extras/CNH",
                          "icon-pack": "feather",
                          icon: "icon-info",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [
                            _c("student-edit-tab-additional-information", {
                              ref: "student_edit_tab_additional_information",
                              staticClass: "mt-4",
                              attrs: { states: _vm.states },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Contrato",
                          "icon-pack": "feather",
                          icon: "icon-file-text",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [
                            _c("student-edit-tab-contract", {
                              staticClass: "mt-4",
                              attrs: { states: _vm.states },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Financeiro",
                          "icon-pack": "feather",
                          icon: "icon-dollar-sign",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [
                            _c("student-edit-tab-financial", {
                              staticClass: "mt-4",
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Taxas",
                          "icon-pack": "feather",
                          icon: "icon-dollar-sign",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [_c("student-edit-tab-tax", { staticClass: "mt-4" })],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Agenda Aula",
                          "icon-pack": "feather",
                          icon: "icon-calendar",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [
                            _c("student-edit-tab-class-schedule", {
                              staticClass: "mt-4",
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Agenda Exame",
                          "icon-pack": "feather",
                          icon: "icon-calendar",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [
                            _c("student-edit-tab-exam-schedule", {
                              staticClass: "mt-4",
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Documentos",
                          "icon-pack": "feather",
                          icon: "icon-file-text",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [
                            _c("student-edit-tab-documents", {
                              staticClass: "mt-4",
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Observação",
                          "icon-pack": "feather",
                          icon: "icon-file-text",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [
                            _c("student-edit-tab-observation", {
                              staticClass: "mt-4",
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-tab",
                      {
                        attrs: {
                          label: "Protocolo",
                          "icon-pack": "feather",
                          icon: "icon-calendar",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tab-text" },
                          [
                            _c("student-edit-tab-protocol", {
                              staticClass: "mt-4",
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }